const EVENTS_PREFIX = 'EGD'

const ADMIN_EVENTS = {
  // users
  USERS_LIST_PAGE_VIEW: `${EVENTS_PREFIX} Users - Users list Pageview`,
  DEFAULT_POLICY_PAGE_VIEW: `${EVENTS_PREFIX} Users - Default policy Pageview`,
  ADD_UPDATE_USER_PAGE_VIEW: `${EVENTS_PREFIX} Users - Add/Update Users Pageview`,
  QUARANTINE_NOTIFICATION_PAGE_VIEW: `${EVENTS_PREFIX} Users - Quarantine notification PageView`,
  EMAIL_CONTINUITY_PAGE_VIEW: `${EVENTS_PREFIX} Users - Email Continuity pageview`,
  // Incomplete setup
  INCOMPLETE_IP_OR_IR: 'Incomplete IP or IR setup for full email entitlements'
} as const

export default ADMIN_EVENTS
